import React from 'react';

export const GMAIL_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.9"
      d="M14.8771 4.22784V9.64829L10.0007 13.3083L5.11267 9.64829V4.22784L10.0007 7.88781L14.8771 4.22784Z"
      fill="#EA4335"
    />
    <path
      d="M19 5.11954V6.55572L14.8765 9.63658V4.22771L16.5097 3H16.8688C18.0502 3 19 3.94974 19 5.11954Z"
      fill="#FBBC04"
    />
    <path
      opacity="0.8"
      d="M19 6.5672V14.223C19 15.3928 18.0502 16.3425 16.8803 16.3425H14.8765V9.64805L19 6.5672Z"
      fill="#34A853"
    />
    <path
      opacity="0.9"
      d="M5.11225 9.64805V16.331H3.1084C1.95011 16.331 1.00031 15.3812 1.00031 14.2114V6.5672L5.11225 9.64805Z"
      fill="#4285F4"
    />
    <path
      d="M5.11194 4.22808V9.64855L1 6.56768V5.11991C1 3.95011 1.9498 3.00037 3.10809 3.00037H3.47875L5.11194 4.22808Z"
      fill="#C5221F"
    />
  </svg>
);

export const GMAIL_CHROME_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M9.65838 8.45473H0.652942C0.303773 8.45473 0.00976563 8.18134 0.00976563 7.8374V1.59365C0.00972519 1.25852 0.294552 0.976318 0.652942 0.976318H9.65838C10.0076 0.976318 10.3016 1.24971 10.3016 1.59365V7.8374C10.3016 8.18134 10.0168 8.45473 9.65838 8.45473Z"
        fill="#E3E3E3"
      />
      <path
        opacity="0.1"
        d="M1.29642 8.45503L5.1467 5.48305L5.17428 5.32431L1.20453 2.58167L1.19531 8.32276L1.29642 8.45503Z"
        fill="#231F20"
      />
      <path
        d="M0.652983 8.45539C0.294593 8.45539 0.00976562 8.18201 0.00976562 7.83806V1.58547C0.00976562 1.24156 0.294593 1.17981 0.652983 1.17981C1.01137 1.17981 1.29624 1.25037 1.29624 1.58547V8.45539H0.652983Z"
        fill="#D54B3D"
      />
      <path
        d="M0.652942 1.26799C1.11239 1.26799 1.20432 1.4003 1.20432 1.58547V8.36722H0.652942C0.349714 8.36722 0.101608 8.12911 0.101608 7.83806V1.58547C0.101608 1.39145 0.19349 1.26799 0.652942 1.26799ZM0.652942 1.17981C0.294552 1.17981 0.00976562 1.25037 0.00976562 1.58547V7.8381C0.00976562 8.18205 0.294593 8.45543 0.652983 8.45543H1.2962V1.58547C1.2962 1.24156 1.01133 1.17981 0.652942 1.17981Z"
        fill="#D72B27"
      />
      <path
        d="M9.65888 8.45539H9.01562V1.56785C9.01562 1.2239 9.30049 1.17981 9.65888 1.17981C10.0173 1.17981 10.3021 1.2239 10.3021 1.56785V7.84691C10.3021 8.18201 10.0173 8.45539 9.65888 8.45539Z"
        fill="#D54B3D"
      />
      <path
        d="M9.65888 1.26799C10.0724 1.26799 10.2102 1.34736 10.2102 1.56785V7.84691C10.2102 8.13792 9.96211 8.37603 9.65888 8.37603H9.10751V1.56785C9.10751 1.33855 9.24537 1.26799 9.65888 1.26799ZM9.65888 1.17981C9.30049 1.17981 9.01562 1.2239 9.01562 1.56785V8.46424H9.65888C10.0173 8.46424 10.3021 8.19082 10.3021 7.84691V1.56785C10.3021 1.2239 10.0173 1.17981 9.65888 1.17981Z"
        fill="#D72B27"
      />
      <path
        d="M6.90156 8.45466L0.0634766 1.8412L0.42316 1.98158L5.18317 5.27104L10.3016 1.66907V7.84617C10.3016 8.18127 10.0167 8.45466 9.65831 8.45466H6.90156Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M5.14765 5.48295L0.286541 2.09651C0.00167335 1.89368 -0.0810288 1.50564 0.130317 1.23225C0.341743 0.958865 0.755214 0.897155 1.04926 1.09998L5.15687 3.96613L9.29194 1.06467C9.57681 0.861837 9.98114 0.923586 10.1925 1.20578C10.4038 1.47917 10.3395 1.86721 10.0454 2.07004L5.14761 5.48292L5.14765 5.48295Z"
        fill="#D54B3D"
      />
      <path
        d="M9.65976 1.02934C9.83434 1.02934 9.99975 1.10871 10.11 1.24979C10.2846 1.48794 10.2295 1.81422 9.99057 1.99062L5.14786 5.37707L0.34191 2.0259C0.0938036 1.8495 0.0294617 1.51437 0.204046 1.28511C0.305149 1.1528 0.479734 1.06466 0.663499 1.06466C0.782962 1.06466 0.902425 1.0999 0.994307 1.17046L5.09274 4.02775L5.14786 4.06307L5.20298 4.02775L9.32895 1.12637C9.43005 1.06466 9.5403 1.02934 9.65976 1.02934ZM9.65976 0.941162C9.53112 0.941162 9.39325 0.976442 9.28301 1.05581L5.14786 3.9572L1.04025 1.09109C0.930046 1.01172 0.792223 0.976442 0.654359 0.976442C0.452193 0.976442 0.250028 1.06462 0.121385 1.23221C-0.0807809 1.50556 0.00192128 1.89359 0.286789 2.09642L5.1479 5.49172L10.0365 2.06999C10.3214 1.86716 10.3857 1.48794 10.1836 1.20574C10.0549 1.02934 9.86193 0.941162 9.65976 0.941162Z"
        fill="#D72B27"
      />
    </g>
    <g clipPath="url(#clip1)">
      <path
        d="M10.8149 3.7663C10.8149 3.7663 13.8609 3.63014 15.4759 6.67994H10.5557C10.5557 6.67994 9.6272 6.65013 8.83403 7.7722C8.60618 8.24316 8.36127 8.7283 8.63611 9.68439C8.24019 9.01624 6.53418 6.05724 6.53418 6.05724C6.53418 6.05724 7.73751 3.88687 10.8149 3.7663H10.8149Z"
        fill="#EF3F36"
      />
      <path
        d="M15.3183 11.5081C15.3183 11.5081 13.9127 14.2047 10.4551 14.0714C10.8823 13.3352 12.9158 9.82716 12.9158 9.82716C12.9158 9.82716 13.4072 9.04131 12.8276 7.79585C12.5327 7.3632 12.2323 6.91069 11.2639 6.66952C12.0429 6.66247 15.4678 6.66952 15.4678 6.66952C15.4678 6.66952 16.7508 8.79308 15.3183 11.5081Z"
        fill="#FCD900"
      />
      <path
        d="M6.3341 11.53C6.3341 11.53 4.69215 8.96957 6.53772 6.0531C6.96353 6.78933 8.99707 10.2973 8.99707 10.2973C8.99707 10.2973 9.4357 11.1144 10.8071 11.2363C11.3297 11.1981 11.8737 11.1654 12.5687 10.4519C12.1855 11.1272 10.4667 14.0777 10.4667 14.0777C10.4667 14.0777 7.97743 14.1231 6.33406 11.53H6.3341Z"
        fill="#61BC5B"
      />
      <path
        d="M10.4531 14.0969L11.1452 11.2202C11.1452 11.2202 11.9057 11.1606 12.5437 10.4641C12.1477 11.1578 10.4531 14.0969 10.4531 14.0969Z"
        fill="#5AB055"
      />
      <path
        d="M8.49609 8.96357C8.49609 7.69544 9.52856 6.66699 10.8016 6.66699C12.0747 6.66699 13.1072 7.69544 13.1072 8.96357C13.1072 10.2317 12.0747 11.2602 10.8016 11.2602C9.52856 11.2587 8.49609 10.2317 8.49609 8.96357Z"
        fill="white"
      />
      <path
        d="M8.88281 8.96391C8.88281 7.90855 9.74154 7.05176 10.8025 7.05176C11.862 7.05176 12.7221 7.90714 12.7221 8.96391C12.7221 10.0193 11.8634 10.8761 10.8025 10.8761C9.74296 10.8761 8.88281 10.0193 8.88281 8.96391Z"
        fill="url(#paint1_linear)"
      />
      <path
        d="M15.4655 6.67158L12.616 7.50424C12.616 7.50424 12.1859 6.87581 11.2617 6.67158C12.0635 6.66731 15.4655 6.67158 15.4655 6.67158Z"
        fill="#EACA05"
      />
      <path
        d="M8.58058 9.57918C8.18038 8.88836 6.53418 6.05701 6.53418 6.05701L8.64464 8.13654C8.64464 8.13654 8.42816 8.58055 8.50937 9.21602L8.58054 9.57918H8.58058Z"
        fill="#DF3A32"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="0.0638861"
        y1="5.06173"
        x2="10.3048"
        y2="5.06173"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0.1" />
        <stop offset="1" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="10.8024"
        y1="7.07876"
        x2="10.8024"
        y2="10.761"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#86BBE5" />
        <stop offset="1" stopColor="#1072BA" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="10.3529" height="7.52941" fill="white" transform="translate(0 0.941162)" />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="10.3529"
          height="10.3529"
          fill="white"
          transform="translate(5.64746 3.76465)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CHROME_ICON = (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M7.95616 0.00239049C7.95616 0.00239049 12.6453 -0.208038 15.1314 4.5053H7.55715C7.55715 4.5053 6.12774 4.45923 4.90669 6.19333C4.55594 6.92118 4.17891 7.67094 4.60201 9.14854C3.99251 8.11595 1.36621 3.54294 1.36621 3.54294C1.36621 3.54294 3.21866 0.188725 7.95609 0.00239049H7.95616Z"
        fill="#EF3F36"
      />
      <path
        d="M14.8879 11.9672C14.8879 11.9672 12.7241 16.1347 7.40137 15.9286C8.05905 14.7908 11.1896 9.36934 11.1896 9.36934C11.1896 9.36934 11.9459 8.15483 11.0537 6.23004C10.5998 5.5614 10.1372 4.86207 8.64657 4.48934C9.84576 4.47844 15.1182 4.48934 15.1182 4.48934C15.1182 4.48934 17.0933 7.77121 14.8879 11.9672Z"
        fill="#FCD900"
      />
      <path
        d="M1.0565 12.0009C1.0565 12.0009 -1.47118 8.04389 1.36997 3.53662C2.02547 4.67443 5.15599 10.0959 5.15599 10.0959C5.15599 10.0959 5.83123 11.3586 7.94236 11.5471C8.74696 11.4879 9.58438 11.4375 10.6543 10.3348C10.0644 11.3784 7.41834 15.9382 7.41834 15.9382C7.41834 15.9382 3.58631 16.0084 1.05644 12.0009H1.0565Z"
        fill="#61BC5B"
      />
      <path
        d="M7.39844 15.9681L8.46384 11.5223C8.46384 11.5223 9.63451 11.4301 10.6167 10.3538C10.0072 11.4258 7.39844 15.9681 7.39844 15.9681Z"
        fill="#5AB055"
      />
      <path
        d="M4.38672 8.03473C4.38672 6.07489 5.97614 4.48547 7.93598 4.48547C9.89582 4.48547 11.4852 6.07489 11.4852 8.03473C11.4852 9.99464 9.89582 11.584 7.93598 11.584C5.97614 11.5818 4.38672 9.99464 4.38672 8.03473Z"
        fill="white"
      />
      <path
        d="M4.98047 8.0351C4.98047 6.4041 6.30243 5.07996 7.93567 5.07996C9.56668 5.07996 10.8908 6.40192 10.8908 8.0351C10.8908 9.66617 9.56892 10.9903 7.93567 10.9903C6.30461 10.9903 4.98047 9.66617 4.98047 8.0351Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M15.1161 4.49243L10.7293 5.77928C10.7293 5.77928 10.0673 4.80808 8.64453 4.49243C9.87877 4.48584 15.1161 4.49243 15.1161 4.49243Z"
        fill="#EACA05"
      />
      <path
        d="M4.51653 8.98596C3.90044 7.91832 1.36621 3.5426 1.36621 3.5426L4.61514 6.75642C4.61514 6.75642 4.28188 7.44262 4.4069 8.42472L4.51647 8.98596H4.51653Z"
        fill="#DF3A32"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="7.93553"
        y1="5.12168"
        x2="7.93553"
        y2="10.8124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#86BBE5" />
        <stop offset="1" stopColor="#1072BA" />
      </linearGradient>
      <clipPath id="clip0">
        <rect width="15.9377" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SLACK_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2677 2.96676C14.2677 1.88055 13.3862 1 12.2988 1C11.2114 1 10.3299 1.88055 10.3299 2.96676V7.69398C10.3299 8.7802 11.2114 9.66074 12.2988 9.66074C13.3862 9.66074 14.2677 8.7802 14.2677 7.69398V2.96676Z"
      fill="#2EB67D"
    />
    <path
      d="M17.0311 10.3202H12.2988C11.2114 10.3202 10.3299 11.2007 10.3299 12.2869C10.3299 13.3731 11.2114 14.2537 12.2988 14.2537H17.0311C18.1185 14.2537 19 13.3731 19 12.2869C19 11.2007 18.1185 10.3202 17.0311 10.3202Z"
      fill="#ECB22E"
    />
    <path
      d="M9.67048 12.2869C9.67048 11.2007 8.78898 10.3202 7.7016 10.3202C6.61422 10.3202 5.73273 11.2007 5.73273 12.2869V17.0142C5.73273 18.1004 6.61422 18.9809 7.7016 18.9809C8.78898 18.9809 9.67048 18.1004 9.67048 17.0142V12.2869Z"
      fill="#E01E5A"
    />
    <path
      d="M7.7013 5.72714H2.96889C1.8815 5.72714 1 6.60768 1 7.69388C1 8.78008 1.8815 9.66062 2.96889 9.66062H7.7013C8.78869 9.66062 9.67019 8.78008 9.67019 7.69388C9.67019 6.60768 8.78869 5.72714 7.7013 5.72714Z"
      fill="#36C5F0"
    />
    <path
      d="M18.8492 7.68813C18.8492 8.20975 18.6418 8.71001 18.2725 9.07885C17.9033 9.44768 17.4025 9.6549 16.8803 9.6549H14.9523C14.9523 9.00126 14.9114 7.68813 14.9114 7.68813C14.9114 7.42986 14.9623 7.17411 15.0613 6.93549C15.1602 6.69687 15.3053 6.48005 15.4881 6.29742C15.6709 6.11479 15.888 5.96993 16.1268 5.87109C16.3657 5.77225 16.6217 5.72137 16.8803 5.72137C17.1388 5.72137 17.3949 5.77225 17.6338 5.87109C17.8726 5.96993 18.0897 6.11479 18.2725 6.29742C18.4553 6.48005 18.6003 6.69687 18.6993 6.93549C18.7982 7.17411 18.8492 7.42986 18.8492 7.68813Z"
      fill="#2EB67D"
    />
    <path
      d="M12.2988 18.8234C11.7766 18.8234 11.2758 18.6162 10.9066 18.2473C10.5373 17.8785 10.3299 17.3782 10.3299 16.8566V14.9366C10.9901 14.9366 12.2988 14.8899 12.2988 14.8899C12.82 14.8914 13.3193 15.0993 13.6873 15.468C14.0552 15.8367 14.2619 16.336 14.2619 16.8566C14.2619 17.3772 14.0552 17.8766 13.6873 18.2453C13.3193 18.6139 12.82 18.8218 12.2988 18.8234Z"
      fill="#ECB22E"
    />
    <path
      d="M1.1579 12.3046C1.1579 11.7829 1.36534 11.2827 1.73457 10.9138C2.10381 10.545 2.60459 10.3378 3.12677 10.3378H5.0489C5.0489 10.9914 5.09565 12.3046 5.09565 12.3046C5.09565 12.8262 4.88821 13.3264 4.51897 13.6953C4.14973 14.0641 3.64895 14.2713 3.12677 14.2713C2.60459 14.2713 2.10381 14.0641 1.73457 13.6953C1.36534 13.3264 1.1579 12.8262 1.1579 12.3046Z"
      fill="#E01E5A"
    />
    <path
      d="M7.7016 1.15167C8.22378 1.15167 8.72456 1.35888 9.0938 1.72772C9.46304 2.09656 9.67048 2.59681 9.67048 3.11843V5.04434C9.01029 5.04434 7.7016 5.0852 7.7016 5.0852C7.17942 5.0852 6.6786 4.87798 6.30937 4.50914C5.94013 4.1403 5.73273 3.64005 5.73273 3.11843C5.73273 2.59681 5.94013 2.09656 6.30937 1.72772C6.6786 1.35888 7.17942 1.15167 7.7016 1.15167Z"
      fill="#36C5F0"
    />
  </svg>
);

export const TEAMS_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.75"
      d="M10.3901 7.44586C11.8956 7.44586 13.116 6.22678 13.116 4.72294C13.116 3.2191 11.8956 2 10.3901 2C8.88461 2 7.66415 3.2191 7.66415 4.72294C7.66415 6.22678 8.88461 7.44586 10.3901 7.44586Z"
      fill="#7B83EB"
    />
    <path
      opacity="0.75"
      d="M14.9368 9.13413V14.5004C14.9389 14.9056 14.8853 15.3092 14.7775 15.6999C14.5199 16.6768 13.9459 17.5412 13.145 18.1582C12.3442 18.7752 11.3614 19.11 10.35 19.1106C9.22664 19.1099 8.14259 18.6975 7.30343 17.9514C6.46428 17.2054 5.92839 16.1777 5.79737 15.0632C5.76979 14.8845 5.7565 14.7039 5.75757 14.5231V12.7893H5.86566V9.06022H7.35095V8.49176H14.2937C14.3914 8.49159 14.4879 8.5129 14.5764 8.55416C14.6649 8.59542 14.7433 8.65564 14.8059 8.73052C14.8957 8.84548 14.9421 8.9884 14.9368 9.13413Z"
      fill="#7B83EB"
    />
    <path
      d="M16.2228 7.17298C17.2851 7.17298 18.1463 6.31273 18.1463 5.25156C18.1463 4.19039 17.2851 3.33014 16.2228 3.33014C15.1605 3.33014 14.2993 4.19039 14.2993 5.25156C14.2993 6.31273 15.1605 7.17298 16.2228 7.17298Z"
      fill="#5059C9"
    />
    <path
      d="M19 9.70829V12.795C19.0007 13.2021 18.921 13.6053 18.7654 13.9815C18.6098 14.3578 18.3814 14.6996 18.0933 14.9874C17.8051 15.2752 17.4629 15.5034 17.0863 15.6589C16.7097 15.8143 16.306 15.8939 15.8985 15.8932C15.5105 15.8986 15.1248 15.8331 14.7604 15.6999C14.8682 15.3092 14.9219 14.9057 14.9197 14.5004V9.14551C14.9232 8.99642 14.8726 8.8511 14.7775 8.73621H17.9984C18.2601 8.73317 18.5123 8.8337 18.7 9.01585C18.8876 9.19799 18.9955 9.44694 19 9.70829Z"
      fill="#5059C9"
    />
    <path
      d="M9.22892 6.04736H1.77394C1.56868 6.04736 1.37182 6.12881 1.22667 6.2738C1.08153 6.41878 1 6.61543 1 6.82047V14.2673C1.00299 14.4704 1.08581 14.6641 1.23063 14.8066C1.37546 14.9492 1.57064 15.0291 1.77394 15.029H9.22892C9.43277 15.0291 9.62852 14.9494 9.77425 14.807C9.91998 14.6646 10.0041 14.4709 10.0086 14.2673V6.82047C10.0071 6.61491 9.92426 6.41828 9.77821 6.27345C9.63216 6.12863 9.43471 6.04736 9.22892 6.04736ZM7.33953 9.02609H5.85423V12.7552H5.11446V9.02609H3.66897V8.29278H7.36801L7.33953 9.02609Z"
      fill="#464EB7"
    />
  </svg>
);

export const ZENDESK_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.32916 3H1.01087C1.0101 3.54647 1.11719 4.08773 1.32601 4.59283C1.53482 5.09793 1.84126 5.55694 2.22782 5.94363C2.61439 6.33032 3.07348 6.63709 3.57883 6.8464C4.08418 7.0557 4.62589 7.16343 5.17296 7.16343C6.27633 7.16032 7.33343 6.7203 8.11253 5.93984C8.89163 5.15938 9.32917 4.10218 9.32916 3Z"
      fill="#333333"
    />
    <path d="M9.32418 6.64667V16.6823H1L9.32418 6.64667Z" fill="#333333" />
    <path
      d="M10.6699 16.6823H19C19 16.1363 18.8924 15.5957 18.6832 15.0913C18.474 14.5868 18.1674 14.1285 17.7809 13.7424C17.3945 13.3564 16.9356 13.0501 16.4306 12.8412C15.9257 12.6323 15.3845 12.5247 14.8379 12.5247C13.7335 12.5247 12.6742 12.9626 11.8927 13.7421C11.1112 14.5216 10.6714 15.5791 10.6699 16.6823Z"
      fill="#333333"
    />
    <path d="M10.6699 13.0416V3.00586H18.9999L10.6699 13.0416Z" fill="#333333" />
  </svg>
);

export const OUTLOOK_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.29621 12.5145C7.048 12.5145 7.65746 11.5294 7.65746 10.3142C7.65746 9.099 7.048 8.11389 6.29621 8.11389C5.54442 8.11389 4.93497 9.099 4.93497 10.3142C4.93497 11.5294 5.54442 12.5145 6.29621 12.5145Z"
      fill="#0072C6"
    />
    <path
      d="M1 3.38571V17.1128L11.5679 19.48V1L1 3.38571ZM6.30251 13.5651C4.94748 13.5651 3.88951 12.1374 3.88951 10.3141C3.88951 8.49087 4.94748 7.05698 6.30251 7.05698C7.65753 7.05698 8.72177 8.48468 8.72177 10.3141C8.72177 12.1436 7.6576 13.5651 6.29639 13.5651H6.30251Z"
      fill="#0072C6"
    />
    <path
      d="M13.617 9.46123L12.2867 8.47851V4.93085H18.0534C18.2921 4.93012 18.5223 5.0195 18.6978 5.1811C18.8733 5.3427 18.9813 5.56459 19 5.80232L13.617 9.46123Z"
      fill="#0072C6"
    />
    <path
      d="M19 7.07562V13.7878C19 13.9116 18.9755 14.0343 18.9279 14.1487C18.8802 14.2631 18.8103 14.3669 18.7223 14.4543C18.6344 14.5416 18.53 14.6106 18.4152 14.6575C18.3003 14.7043 18.1774 14.728 18.0534 14.7272H12.2867V9.78272L13.5922 10.7469L19 7.07562Z"
      fill="#0072C6"
    />
  </svg>
);

export const GLIA_ICON = (
  <svg width="16" viewBox="0 0 11 16" fill="none">
    <rect width="11" height="16" fill="url(#pattern0)" />
    <defs>
      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use href="#image0" transform="scale(0.0294118 0.0212766)" />
      </pattern>
      <image
        id="image0"
        width="100"
        height="47"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const TWITTER_ICON = (
  <svg width="100%" viewBox="0 0 248 204">
    <g fill="#1D9BF0">
      <path d="M221.95,51.29c0.15,2.17,0.15,4.34,0.15,6.53c0,66.73-50.8,143.69-143.69,143.69v-0.04C50.97,201.51,24.1,193.65,1,178.83c3.99,0.48,8,0.72,12.02,0.73c22.74,0.02,44.83-7.61,62.72-21.66c-21.61-0.41-40.56-14.5-47.18-35.07c7.57,1.46,15.37,1.16,22.8-0.87C27.8,117.2,10.85,96.5,10.85,72.46c0-0.22,0-0.43,0-0.64c7.02,3.91,14.88,6.08,22.92,6.32C11.58,63.31,4.74,33.79,18.14,10.71c25.64,31.55,63.47,50.73,104.08,52.76c-4.07-17.54,1.49-35.92,14.61-48.25c20.34-19.12,52.33-18.14,71.45,2.19c11.31-2.23,22.15-6.38,32.07-12.26c-3.77,11.69-11.66,21.62-22.2,27.93c10.01-1.18,19.79-3.86,29-7.95C240.37,35.29,231.83,44.14,221.95,51.29z" />
    </g>
  </svg>
);

export const SALESFORCE_ICON = (
  <svg width="100%" viewBox="0 0 273 191">
    <defs>
      <path id="a" d="m0.06 0.5h272v190h-272z" />
    </defs>
    <g fillRule="evenodd">
      <path
        d="m113 21.3c8.78-9.14 21-14.8 34.5-14.8 18 0 33.6 10 42 24.9a58 58 0 0 1 23.7-5.05c32.4 0 58.7 26.5 58.7 59.2s-26.3 59.2-58.7 59.2c-3.96 0-7.82-0.398-11.6-1.15-7.35 13.1-21.4 22-37.4 22a42.7 42.7 0 0 1-18.8-4.32c-7.45 17.5-24.8 29.8-45 29.8-21.1 0-39-13.3-45.9-32a45.1 45.1 0 0 1-9.34 0.972c-25.1 0-45.4-20.6-45.4-45.9 0-17 9.14-31.8 22.7-39.8a52.6 52.6 0 0 1-4.35-21c0-29.2 23.7-52.8 52.9-52.8 17.1 0 32.4 8.15 42 20.8"
        fill="#00A1E0"
      />
    </g>
  </svg>
);

export const HUBSPOT_ICON = (
  <svg width="100%" viewBox="6.20856283 .64498824 244.26943717 251.24701176">
    <path
      d="m191.385 85.694v-29.506a22.722 22.722 0 0 0 13.101-20.48v-.677c0-12.549-10.173-22.722-22.721-22.722h-.678c-12.549 0-22.722 10.173-22.722 22.722v.677a22.722 22.722 0 0 0 13.101 20.48v29.506a64.342 64.342 0 0 0 -30.594 13.47l-80.922-63.03c.577-2.083.878-4.225.912-6.375a25.6 25.6 0 1 0 -25.633 25.55 25.323 25.323 0 0 0 12.607-3.43l79.685 62.007c-14.65 22.131-14.258 50.974.987 72.7l-24.236 24.243c-1.96-.626-4-.959-6.057-.987-11.607.01-21.01 9.423-21.007 21.03.003 11.606 9.412 21.014 21.018 21.017 11.607.003 21.02-9.4 21.03-21.007a20.747 20.747 0 0 0 -.988-6.056l23.976-23.985c21.423 16.492 50.846 17.913 73.759 3.562 22.912-14.352 34.475-41.446 28.985-67.918-5.49-26.473-26.873-46.734-53.603-50.792m-9.938 97.044a33.17 33.17 0 1 1 0-66.316c17.85.625 32 15.272 32.01 33.134.008 17.86-14.127 32.522-31.977 33.165"
      fill="#ff7a59"
    />
  </svg>
);

export const SERVER_SIDE_ICON = (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    className="text-litlingo-info-medium"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="8" height="8" rx="4" fill="currentColor" />
  </svg>
);

export const OK_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 10L9 12L13 8M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WRONG_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 12L10 10L8 12ZM10 10L12 8L10 10ZM10 10L8 8L10 10ZM10 10L12 12L10 10ZM19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
      stroke="#4A5568"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const STAR_ICON = (fill: string | null, stroke: string | null, size = 20): JSX.Element => (
  <svg
    className="m-auto text-gray-700"
    width={size}
    height={size}
    fill={fill || 'none'}
    stroke={stroke || 'currentColor'}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
    />
  </svg>
);

export const WARNING_ICON = (
  <svg width="22" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5601 15.3007L13.8901 2.58067C13.58 2.09549 13.1527 1.69619 12.6476 1.41961C12.1425 1.14302 11.5759 0.998047 11.0001 0.998047C10.4243 0.998047 9.85769 1.14302 9.35262 1.41961C8.84755 1.69619 8.42024 2.09549 8.1101 2.58067L0.4401 15.3007C0.169154 15.7523 0.021889 16.2674 0.013112 16.794C0.00433502 17.3206 0.134355 17.8402 0.3901 18.3007C0.685779 18.8189 1.11376 19.2494 1.6303 19.5481C2.14684 19.8468 2.73343 20.0029 3.3301 20.0007H18.6701C19.2629 20.007 19.8468 19.8569 20.363 19.5654C20.8792 19.2739 21.3093 18.8515 21.6101 18.3407C21.8734 17.8754 22.0075 17.3483 21.9987 16.8139C21.9899 16.2794 21.8385 15.757 21.5601 15.3007ZM19.8601 17.3507C19.7399 17.5573 19.5655 17.727 19.3557 17.8416C19.146 17.9562 18.9089 18.0112 18.6701 18.0007H3.3301C3.09132 18.0112 2.85422 17.9562 2.64446 17.8416C2.4347 17.727 2.26029 17.5573 2.1401 17.3507C2.05233 17.1987 2.00613 17.0262 2.00613 16.8507C2.00613 16.6751 2.05233 16.5027 2.1401 16.3507L9.8201 3.62067C9.9581 3.43838 10.1365 3.29053 10.3412 3.18874C10.5459 3.08695 10.7715 3.03398 11.0001 3.03398C11.2287 3.03398 11.4543 3.08695 11.659 3.18874C11.8637 3.29053 12.0421 3.43838 12.1801 3.62067L19.8501 16.3407C19.9413 16.493 19.9902 16.6668 19.992 16.8443C19.9937 17.0218 19.9482 17.1966 19.8601 17.3507Z"
      fill="#E47411"
    />
    <path
      d="M11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16Z"
      fill="#E47411"
    />
    <path
      d="M11 7C10.7348 7 10.4804 7.10536 10.2929 7.29289C10.1054 7.48043 10 7.73478 10 8V12C10 12.2652 10.1054 12.5196 10.2929 12.7071C10.4804 12.8946 10.7348 13 11 13C11.2652 13 11.5196 12.8946 11.7071 12.7071C11.8946 12.5196 12 12.2652 12 12V8C12 7.73478 11.8946 7.48043 11.7071 7.29289C11.5196 7.10536 11.2652 7 11 7Z"
      fill="#E47411"
    />
  </svg>
);

export const AGAINST_POLICY_ICON = (
  <svg width="23" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 6.5C15.08 6.5 14.67 6.54 14.26 6.61L0.00999999 0.5L0 7.5L9 9.5L0 11.5L0.00999999 18.5L8.08 15.04C8.59 18.69 11.71 21.5 15.5 21.5C19.64 21.5 23 18.14 23 14C23 9.86 19.64 6.5 15.5 6.5ZM15.5 19.5C12.47 19.5 10 17.03 10 14C10 10.97 12.47 8.5 15.5 8.5C18.53 8.5 21 10.97 21 14C21 17.03 18.53 19.5 15.5 19.5Z"
      fill="#EB5757"
    />
    <path
      d="M17.27 11.5293L15.5 13.2893L13.73 11.5293L13.03 12.2293L14.79 13.9993L13.03 15.7693L13.73 16.4693L15.5 14.7093L17.27 16.4693L17.97 15.7693L16.21 13.9993L17.97 12.2293L17.27 11.5293Z"
      fill="#EB5757"
    />
  </svg>
);

export const EDITED_ICON = (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 4.99919H6C5.46957 4.99919 4.96086 5.2099 4.58579 5.58497C4.21071 5.96004 4 6.46875 4 6.99919V17.9992C4 18.5296 4.21071 19.0383 4.58579 19.4134C4.96086 19.7885 5.46957 19.9992 6 19.9992H17C17.5304 19.9992 18.0391 19.7885 18.4142 19.4134C18.7893 19.0383 19 18.5296 19 17.9992V12.9992M17.586 3.58519C17.7705 3.39417 17.9912 3.2418 18.2352 3.13698C18.4792 3.03216 18.7416 2.97699 19.0072 2.97468C19.2728 2.97238 19.5361 3.02298 19.7819 3.12354C20.0277 3.2241 20.251 3.37261 20.4388 3.5604C20.6266 3.74818 20.7751 3.97148 20.8756 4.21728C20.9762 4.46307 21.0268 4.72643 21.0245 4.99199C21.0222 5.25755 20.967 5.51999 20.8622 5.76399C20.7574 6.008 20.605 6.22869 20.414 6.41319L11.828 14.9992H9V12.1712L17.586 3.58519Z"
      stroke="#2F80ED"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WITHIN_POLICY_ICON = (
  <svg width="22" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0.5V7.5L15 9.5L0 11.5V18.5L21 9.5L0 0.5ZM20 13L16.5 16.5L14.5 14.5L13 16L16.5 19.5L21.5 14.5L20 13Z"
      fill="#219653"
    />
  </svg>
);

export const LINE_ICON = (
  <svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="0.5" x2="8" y2="0.5" stroke="#333333" />
  </svg>
);

export const BUCKET_ICON = (
  <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.27641 0.671094C5.20179 0.641191 5.11852 0.641191 5.04391 0.671094L1.31391 2.16297L5.16016 3.70109L9.00641 2.16297L5.27641 0.671094ZM9.53516 2.62484L5.47266 4.24984V9.20109L9.53516 7.57609V2.62547V2.62484ZM4.84766 9.20172V4.24922L0.785156 2.62484V7.57672L4.84766 9.20172ZM4.81203 0.0904691C5.03551 0.00109364 5.2848 0.00109364 5.50828 0.0904691L9.96391 1.87297C10.0218 1.89618 10.0715 1.93621 10.1065 1.9879C10.1414 2.03959 10.1601 2.10056 10.1602 2.16297V7.57672C10.1601 7.70161 10.1226 7.82361 10.0525 7.92699C9.98244 8.03037 9.88301 8.11038 9.76703 8.15672L5.27641 9.95297C5.20179 9.98287 5.11852 9.98287 5.04391 9.95297L0.553906 8.15672C0.437813 8.11048 0.338245 8.03051 0.268058 7.92712C0.19787 7.82373 0.160285 7.70168 0.160156 7.57672V2.16297C0.160171 2.10056 0.178871 2.03959 0.213848 1.9879C0.248825 1.93621 0.298477 1.89618 0.356406 1.87297L4.81203 0.0904691Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const EXTERNAL_LINK_ICON = (width = 10, height = 10): JSX.Element => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 2H2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V8C1 8.26522 1.10536 8.51957 1.29289 8.70711C1.48043 8.89464 1.73478 9 2 9H7C7.26522 9 7.51957 8.89464 7.70711 8.70711C7.89464 8.51957 8 8.26522 8 8V6M6 1H9M9 1V4M9 1L4 6"
      stroke="#BDBDBD"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BRANCH_ICON = (
  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 7C6.1907 7.00055 5.88918 7.09703 5.637 7.27613C5.38483 7.45523 5.19441 7.70814 5.092 8H3.5C2.673 8 2 7.327 2 6.5V4.9875C2.43036 5.31803 2.95736 5.49808 3.5 5.5H5.092C5.19441 5.79186 5.38483 6.04477 5.637 6.22387C5.88918 6.40297 6.1907 6.49945 6.5 6.5C6.89782 6.5 7.27936 6.34196 7.56066 6.06066C7.84196 5.77936 8 5.39782 8 5C8 4.60218 7.84196 4.22064 7.56066 3.93934C7.27936 3.65804 6.89782 3.5 6.5 3.5C6.1907 3.50055 5.88918 3.59703 5.637 3.77613C5.38483 3.95523 5.19441 4.20814 5.092 4.5H3.5C2.673 4.5 2 3.827 2 3V2.908C2.29186 2.80559 2.54477 2.61517 2.72387 2.363C2.90297 2.11082 2.99945 1.8093 3 1.5C3 1.30302 2.9612 1.10796 2.88582 0.925975C2.81044 0.743986 2.69995 0.578628 2.56066 0.43934C2.42137 0.300052 2.25601 0.189563 2.07403 0.114181C1.89204 0.0387986 1.69698 0 1.5 0C1.30302 0 1.10796 0.0387986 0.925975 0.114181C0.743986 0.189563 0.578628 0.300052 0.43934 0.43934C0.300052 0.578628 0.189563 0.743986 0.114181 0.925975C0.0387987 1.10796 -2.93527e-09 1.30302 0 1.5C0.000553322 1.8093 0.0970294 2.11082 0.276131 2.363C0.455232 2.61517 0.708141 2.80559 1 2.908V6.5C1 7.8785 2.1215 9 3.5 9H5.092C5.19441 9.29186 5.38483 9.54477 5.637 9.72387C5.88918 9.90297 6.1907 9.99945 6.5 10C6.89782 10 7.27936 9.84196 7.56066 9.56066C7.84196 9.27936 8 8.89782 8 8.5C8 8.10218 7.84196 7.72064 7.56066 7.43934C7.27936 7.15804 6.89782 7 6.5 7ZM6.5 4.5C6.59903 4.4999 6.69587 4.52918 6.77825 4.58414C6.86063 4.6391 6.92486 4.71726 6.96281 4.80874C7.00075 4.90021 7.0107 5.00089 6.99141 5.09802C6.97211 5.19515 6.92443 5.28438 6.85441 5.35441C6.78438 5.42443 6.69515 5.47211 6.59802 5.49141C6.50089 5.5107 6.40021 5.50075 6.30874 5.46281C6.21726 5.42486 6.1391 5.36063 6.08414 5.27825C6.02918 5.19587 5.9999 5.09903 6 5C6 4.7245 6.224 4.5 6.5 4.5ZM1.5 1C1.59903 0.999901 1.69587 1.02918 1.77825 1.08414C1.86063 1.1391 1.92486 1.21726 1.96281 1.30874C2.00075 1.40021 2.0107 1.50089 1.99141 1.59802C1.97211 1.69515 1.92443 1.78438 1.85441 1.85441C1.78438 1.92443 1.69515 1.97211 1.59802 1.99141C1.50089 2.0107 1.40021 2.00075 1.30874 1.96281C1.21726 1.92486 1.1391 1.86063 1.08414 1.77825C1.02918 1.69587 0.999901 1.59903 1 1.5C1 1.2245 1.224 1 1.5 1ZM6.5 9C6.37126 8.99424 6.2497 8.93905 6.16064 8.84591C6.07157 8.75277 6.02187 8.62887 6.02187 8.5C6.02187 8.37113 6.07157 8.24723 6.16064 8.15409C6.2497 8.06095 6.37126 8.00576 6.5 8C6.62874 8.00576 6.7503 8.06095 6.83936 8.15409C6.92843 8.24723 6.97813 8.37113 6.97813 8.5C6.97813 8.62887 6.92843 8.75277 6.83936 8.84591C6.7503 8.93905 6.62874 8.99424 6.5 9Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const LEFT_ARROW_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 12H21M10 19L3 12L10 19ZM3 12L10 5L3 12Z"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const STATE_CHANGE_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="5" fill="#56CCF2" />
  </svg>
);

export const GRAY_SQUARE_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="1" fill="#F2F2F2" />
  </svg>
);

export const VERTICAL_LINE_ICON = (
  <svg width="20" height="26" viewBox="0 0 1 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2="26" stroke="#BDBDBD" />
  </svg>
);

export const VERTICAL_LINE_2_ICON = (
  <svg width="6" height="20" viewBox="0 0 6 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="3" y1="-1.31134e-07" x2="3" y2="20" stroke="#E0E0E0" strokeWidth="6" />
  </svg>
);

export const INBOUND_ICON = (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"
    />
  </svg>
);

export const ARROW_CLOSE_ENVELOPE = (disabled?: boolean): JSX.Element => (
  <svg
    data-testid="arrow-close-envelope"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.44392 7.50974L3 13.166L4.91123 15L12.0926 7.50965L4.91123 2.00272e-05L3 1.834L8.44392 7.50974Z"
      fill={`${disabled ? '#ADADAD' : '#333333'}`}
    />
  </svg>
);

export const ARROW_OPEN_ENVELOPE = (disabled?: boolean): JSX.Element => (
  <svg
    data-testid="arrow-open-envelope"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49026 8.44392L1.83398 3L0 4.91123L7.49035 12.0926L15 4.91123L13.166 3L7.49026 8.44392Z"
      fill={`${disabled ? '#ADADAD' : '#333333'}`}
    />
  </svg>
);

export const REMOVE_ICON = (color = 'text-litlingo-gray-3'): JSX.Element => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={color}
  >
    <path
      d="M1.67993 1.67999L10.4159 10.4172"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4159 1.67999L1.67993 10.4172"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CHECK_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.9165 7.58331L5.24984 9.91665L11.0832 4.08331"
      stroke="#333333"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BAN_ICON = (color?: string): JSX.Element => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.7124 10.7123L3.2877 3.28764M10.7124 10.7123C11.6969 9.72773 12.2501 8.39237 12.2501 6.99997C12.2501 5.60758 11.6969 4.27221 10.7124 3.28764C9.72779 2.30307 8.39243 1.74994 7.00003 1.74994C5.60764 1.74994 4.27227 2.30307 3.2877 3.28764L10.7124 10.7123ZM10.7124 10.7123C9.72779 11.6969 8.39243 12.25 7.00003 12.25C5.60764 12.25 4.27227 11.6969 3.2877 10.7123C2.30313 9.72773 1.75 8.39237 1.75 6.99997C1.75 5.60758 2.30313 4.27221 3.2877 3.28764L10.7124 10.7123Z"
      stroke={color || '#333333'}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ADD_TEST_CASE_ICON = (
  <svg
    width="77"
    height="29.000000000000004"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="text-litlingo-primary-120"
  >
    <g>
      <text
        stroke="null"
        fill="currentColor"
        x="17.85716"
        y="11.99668"
        id="svg_4"
        strokeWidth="0"
        fontSize="12"
        fontFamily="sans-serif"
        textAnchor="start"
        xmlSpace="preserve"
        fontWeight="normal"
        fontStyle="normal"
      >
        Add to
      </text>
      <text
        xmlSpace="preserve"
        textAnchor="start"
        fontFamily="sans-serif"
        fontSize="12"
        id="svg_3"
        y="26.46152"
        x="17.85098"
        strokeWidth="0"
        fill="currentColor"
      >
        training set
      </text>
      <g id="svg_5">
        <path
          d="m1.21122,20.044l3.28878,0l0.5,0.9855l-4.01807,0c-0.941,0 -1.21914,-0.4712 -0.77603,-1.2253l4.71946,-7.82659l0,-4.49207l-0.93125,0c-0.69657,0 -0.69657,-0.98554 0,-0.98554l6.78319,0c0.6966,0 0.6966,0.98554 0,0.98554l-0.93123,0l0,4.49207l1.15393,2.02239l-1,0l-1.1526,-1.77061l0,-4.74385l-2.92336,0l0,4.74385l-4.71282,7.81461z"
          fill="currentColor"
          id="svg_1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m9.71436,22.5c1.06084,0 2.07824,-0.4214 2.82844,-1.1716c0.7501,-0.7501 1.1716,-1.7675 1.1716,-2.8284c0,-1.0609 -0.4215,-2.07828 -1.1716,-2.82843c-0.7502,-0.75014 -1.7676,-1.17157 -2.82844,-1.17157c-1.06087,0 -2.07829,0.42143 -2.82843,1.17157c-0.75015,0.75015 -1.17157,1.76753 -1.17157,2.82843c0,1.0609 0.42142,2.0783 1.17157,2.8284c0.75014,0.7502 1.76756,1.1716 2.82843,1.1716zm0.50004,-5.5c0,-0.1326 -0.0527,-0.2598 -0.1465,-0.3536c-0.09376,-0.0937 -0.22094,-0.1464 -0.35354,-0.1464c-0.13261,0 -0.25979,0.0527 -0.35356,0.1464c-0.09377,0.0938 -0.14644,0.221 -0.14644,0.3536l0,1l-1,0c-0.13261,0 -0.25979,0.0527 -0.35356,0.1464c-0.09377,0.0938 -0.14644,0.221 -0.14644,0.3536c0,0.1326 0.05267,0.2598 0.14644,0.3536c0.09377,0.0937 0.22095,0.1464 0.35356,0.1464l1,0l0,1c0,0.1326 0.05267,0.2598 0.14644,0.3536c0.09377,0.0937 0.22095,0.1464 0.35356,0.1464c0.1326,0 0.25978,-0.0527 0.35354,-0.1464c0.0938,-0.0938 0.1465,-0.221 0.1465,-0.3536l0,-1l1,0c0.1326,0 0.2597,-0.0527 0.3535,-0.1464c0.0938,-0.0938 0.1465,-0.221 0.1465,-0.3536c0,-0.1326 -0.0527,-0.2598 -0.1465,-0.3536c-0.0938,-0.0937 -0.2209,-0.1464 -0.3535,-0.1464l-1,0l0,-1z"
          fill="currentColor"
          id="svg_2"
        />
      </g>
    </g>
  </svg>
);

export const VIEW_TEST_CASE_ICON = (
  <svg
    width="68"
    height="15"
    viewBox="0 0 68 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-litlingo-primary-120"
  >
    <path
      d="M1.21122 13.544H8.71736V14.5295H0.981931C0.040931 14.5295 -0.237212 14.0583 0.205895 13.3042L4.92536 5.47761V0.985536H3.99411C3.29754 0.985536 3.29754 0 3.99411 0H10.7773C11.4739 0 11.4739 0.985536 10.7773 0.985536H9.84607V5.72939H8.8474V0.985536H5.92404V5.72939L1.21122 13.544ZM6.05407 7.50161L3.02472 12.5784L11.5 12.5L9.27386 8.54596L8.71736 7.50161H6.05407Z"
      fill="currentColor"
    />
    <path
      d="M13.2888 13.544H7.94771V14.5295H13.5181C14.4591 14.5295 14.7372 14.0583 14.2941 13.3042L9.57464 5.47761V0.985536H10.5059C11.2025 0.985536 11.2025 0 10.5059 0H3.72268C3.02607 0 3.02607 0.985536 3.72268 0.985536H4.65393V5.72939H5.6526V0.985536H8.57596V5.72939L13.2888 13.544ZM8.44593 7.50161L11.4753 12.5784L3 12.5L5.22614 8.54596L5.78264 7.50161H8.44593Z"
      fill="currentColor"
    />
    <path
      d="M22.8145 10.5059L25.252 3.46875H26.4824L23.3184 12H22.3223L19.1641 3.46875H20.3887L22.8145 10.5059ZM28.6387 12H27.5547V5.66016H28.6387V12ZM27.4668 3.97852C27.4668 3.80273 27.5195 3.6543 27.625 3.5332C27.7344 3.41211 27.8945 3.35156 28.1055 3.35156C28.3164 3.35156 28.4766 3.41211 28.5859 3.5332C28.6953 3.6543 28.75 3.80273 28.75 3.97852C28.75 4.1543 28.6953 4.30078 28.5859 4.41797C28.4766 4.53516 28.3164 4.59375 28.1055 4.59375C27.8945 4.59375 27.7344 4.53516 27.625 4.41797C27.5195 4.30078 27.4668 4.1543 27.4668 3.97852ZM33.0098 12.1172C32.1504 12.1172 31.4512 11.8359 30.9121 11.2734C30.373 10.707 30.1035 9.95117 30.1035 9.00586V8.80664C30.1035 8.17773 30.2227 7.61719 30.4609 7.125C30.7031 6.62891 31.0391 6.24219 31.4688 5.96484C31.9023 5.68359 32.3711 5.54297 32.875 5.54297C33.6992 5.54297 34.3398 5.81445 34.7969 6.35742C35.2539 6.90039 35.4824 7.67773 35.4824 8.68945V9.14062H31.1875C31.2031 9.76562 31.3848 10.2715 31.7324 10.6582C32.084 11.041 32.5293 11.2324 33.0684 11.2324C33.4512 11.2324 33.7754 11.1543 34.041 10.998C34.3066 10.8418 34.5391 10.6348 34.7383 10.377L35.4004 10.8926C34.8691 11.709 34.0723 12.1172 33.0098 12.1172ZM32.875 6.43359C32.4375 6.43359 32.0703 6.59375 31.7734 6.91406C31.4766 7.23047 31.293 7.67578 31.2227 8.25H34.3984V8.16797C34.3672 7.61719 34.2188 7.19141 33.9531 6.89062C33.6875 6.58594 33.3281 6.43359 32.875 6.43359ZM42.3555 10.5059L43.5742 5.66016H44.6582L42.8125 12H41.9336L40.3926 7.19531L38.8926 12H38.0137L36.1738 5.66016H37.252L38.5 10.4062L39.9766 5.66016H40.8496L42.3555 10.5059ZM50.2129 4.125V5.66016H51.3965V6.49805H50.2129V10.4297C50.2129 10.6836 50.2656 10.875 50.3711 11.0039C50.4766 11.1289 50.6562 11.1914 50.9102 11.1914C51.0352 11.1914 51.207 11.168 51.4258 11.1211V12C51.1406 12.0781 50.8633 12.1172 50.5938 12.1172C50.1094 12.1172 49.7441 11.9707 49.498 11.6777C49.252 11.3848 49.1289 10.9688 49.1289 10.4297V6.49805H47.9746V5.66016H49.1289V4.125H50.2129ZM55.2988 12.1172C54.4395 12.1172 53.7402 11.8359 53.2012 11.2734C52.6621 10.707 52.3926 9.95117 52.3926 9.00586V8.80664C52.3926 8.17773 52.5117 7.61719 52.75 7.125C52.9922 6.62891 53.3281 6.24219 53.7578 5.96484C54.1914 5.68359 54.6602 5.54297 55.1641 5.54297C55.9883 5.54297 56.6289 5.81445 57.0859 6.35742C57.543 6.90039 57.7715 7.67773 57.7715 8.68945V9.14062H53.4766C53.4922 9.76562 53.6738 10.2715 54.0215 10.6582C54.373 11.041 54.8184 11.2324 55.3574 11.2324C55.7402 11.2324 56.0645 11.1543 56.3301 10.998C56.5957 10.8418 56.8281 10.6348 57.0273 10.377L57.6895 10.8926C57.1582 11.709 56.3613 12.1172 55.2988 12.1172ZM55.1641 6.43359C54.7266 6.43359 54.3594 6.59375 54.0625 6.91406C53.7656 7.23047 53.582 7.67578 53.5117 8.25H56.6875V8.16797C56.6562 7.61719 56.5078 7.19141 56.2422 6.89062C55.9766 6.58594 55.6172 6.43359 55.1641 6.43359ZM62.7227 10.3184C62.7227 10.0254 62.6113 9.79883 62.3887 9.63867C62.1699 9.47461 61.7852 9.33398 61.2344 9.2168C60.6875 9.09961 60.252 8.95898 59.9277 8.79492C59.6074 8.63086 59.3691 8.43555 59.2129 8.20898C59.0605 7.98242 58.9844 7.71289 58.9844 7.40039C58.9844 6.88086 59.2031 6.44141 59.6406 6.08203C60.082 5.72266 60.6445 5.54297 61.3281 5.54297C62.0469 5.54297 62.6289 5.72852 63.0742 6.09961C63.5234 6.4707 63.748 6.94531 63.748 7.52344H62.6582C62.6582 7.22656 62.5312 6.9707 62.2773 6.75586C62.0273 6.54102 61.7109 6.43359 61.3281 6.43359C60.9336 6.43359 60.625 6.51953 60.4023 6.69141C60.1797 6.86328 60.0684 7.08789 60.0684 7.36523C60.0684 7.62695 60.1719 7.82422 60.3789 7.95703C60.5859 8.08984 60.959 8.2168 61.498 8.33789C62.041 8.45898 62.4805 8.60352 62.8164 8.77148C63.1523 8.93945 63.4004 9.14258 63.5605 9.38086C63.7246 9.61523 63.8066 9.90234 63.8066 10.2422C63.8066 10.8086 63.5801 11.2637 63.127 11.6074C62.6738 11.9473 62.0859 12.1172 61.3633 12.1172C60.8555 12.1172 60.4062 12.0273 60.0156 11.8477C59.625 11.668 59.3184 11.418 59.0957 11.0977C58.877 10.7734 58.7676 10.4238 58.7676 10.0488H59.8516C59.8711 10.4121 60.0156 10.7012 60.2852 10.916C60.5586 11.127 60.918 11.2324 61.3633 11.2324C61.7734 11.2324 62.1016 11.1504 62.3477 10.9863C62.5977 10.8184 62.7227 10.5957 62.7227 10.3184ZM66.6895 4.125V5.66016H67.873V6.49805H66.6895V10.4297C66.6895 10.6836 66.7422 10.875 66.8477 11.0039C66.9531 11.1289 67.1328 11.1914 67.3867 11.1914C67.5117 11.1914 67.6836 11.168 67.9023 11.1211V12C67.6172 12.0781 67.3398 12.1172 67.0703 12.1172C66.5859 12.1172 66.2207 11.9707 65.9746 11.6777C65.7285 11.3848 65.6055 10.9688 65.6055 10.4297V6.49805H64.4512V5.66016H65.6055V4.125H66.6895Z"
      fill="currentColor"
    />
  </svg>
);

export const ADJUSTMENT_ICON = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    />
  </svg>
);

// Events status icons

export const NEW_EVENT_STATUS_ACCEPTABLE = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.375 2.27273C0.375 1.22464 1.22464 0.375 2.27273 0.375H21.375V18.375H2.27273C1.22464 18.375 0.375 17.5254 0.375 16.4773V2.27273Z"
      fill="#EDEDED"
      stroke="#BDBDBD"
      strokeWidth="0.75"
    />
    <path
      d="M5.25 10.5L8.25 13.5L15.75 6"
      stroke="#4E4B66"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_EVENT_STATUS_SELECTED_ACCEPTABLE = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2.52273C0 1.26754 1.01753 0.25 2.27273 0.25H21.75V19H2.27273C1.01754 19 0 17.9825 0 16.7273V2.52273Z"
      fill="#72D2B5"
    />
    <path
      d="M5.25 10.75L8.25 13.75L15.75 6.25"
      stroke="#F2F2F2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_EVENT_STATUS_PENDING = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.01172 0.375H20.7163V18.375H1.01172V0.375Z"
      fill="#F2F2F2"
      stroke="#BDBDBD"
      strokeWidth="0.75"
    />
    <circle cx="11.125" cy="9.375" r="4.125" stroke="#4E4B66" strokeWidth="3" />
  </svg>
);
export const NEW_EVENT_STATUS_SELECTED_PENDING = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.636719 0H21.0913V18.75H0.636719V0Z" fill="#00447B" />
    <circle cx="11.125" cy="9.375" r="4.125" stroke="#F9F9F9" strokeWidth="3" />
  </svg>
);

export const NEW_EVENT_STATUS_OUT_OF_POLICY = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.875 0.375H19.2273C20.2754 0.375 21.125 1.22464 21.125 2.27273V16.4773C21.125 17.5254 20.2754 18.375 19.2273 18.375H0.875V0.375Z"
      fill="#EDEDED"
      stroke="#BDBDBD"
      strokeWidth="0.75"
    />
    <path
      d="M6.5 5.25L15.5 14.25M6.5 14.25L15.5 5.25L6.5 14.25Z"
      stroke="#4E4B66"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_EVENT_STATUS_SELECTED_OUT_OF_POLICY = (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 0H19.2273C20.4825 0 21.5 1.01753 21.5 2.27273V16.4773C21.5 17.7325 20.4825 18.75 19.2273 18.75H0.5V0Z"
      fill="#F4B740"
    />
    <path
      d="M6.5 5.25L15.5 14.25M6.5 14.25L15.5 5.25L6.5 14.25Z"
      stroke="#F2F2F2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_INBOUND_ICON = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V8C1 8.26522 1.10536 8.51957 1.29289 8.70711C1.48043 8.89464 1.73478 9 2 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8V2C9 1.73478 8.89464 1.48043 8.70711 1.29289C8.51957 1.10536 8.26522 1 8 1H7M5 0.5V4.5M5 4.5L6.5 3M5 4.5L3.5 3M1 5.5H2.293C2.4256 5.50003 2.55275 5.55273 2.6465 5.6465L3.8535 6.8535C3.94725 6.94727 4.0744 6.99997 4.207 7H5.793C5.9256 6.99997 6.05275 6.94727 6.1465 6.8535L7.3535 5.6465C7.44725 5.55273 7.5744 5.50003 7.707 5.5H9"
      stroke="#6E7191"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NEW_INTERNAL_ICON = (
  <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.5" cy="2.5" r="2.5" fill="#6E7191" />
  </svg>
);

export const NEW_WITHIN_POLICY_ICON = (backgroundColor = '#F2F2F2'): JSX.Element => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="30" height="30" rx="1.5" fill={backgroundColor} />
    <path
      d="M6 7.04883V12.9093L18.5581 14.5837L6 16.2581V22.1186L23.5814 14.5837L6 7.04883ZM22.7442 17.5139L19.814 20.4442L18.1395 18.7698L16.8837 20.0256L19.814 22.9558L24 18.7698L22.7442 17.5139Z"
      fill="#219653"
    />
  </svg>
);

export const NEW_WARNING_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="23.0769" height="23.0769" rx="1.15385" fill="#F2F2F2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1304 5.96398C10.7483 4.86552 12.3289 4.86552 12.946 5.96398L17.4529 13.9763C18.0587 15.0537 17.2809 16.3832 16.0459 16.3832H7.03127C5.7955 16.3832 5.01769 15.0537 5.62346 13.9763L10.1304 5.96398ZM12.3459 13.9609C12.3459 14.1752 12.2608 14.3806 12.1093 14.5321C11.9578 14.6835 11.7524 14.7686 11.5382 14.7686C11.324 14.7686 11.1185 14.6835 10.9671 14.5321C10.8156 14.3806 10.7305 14.1752 10.7305 13.9609C10.7305 13.7467 10.8156 13.5413 10.9671 13.3898C11.1185 13.2383 11.324 13.1532 11.5382 13.1532C11.7524 13.1532 11.9578 13.2383 12.1093 13.3898C12.2608 13.5413 12.3459 13.7467 12.3459 13.9609ZM11.5382 7.49941C11.324 7.49941 11.1185 7.5845 10.9671 7.73597C10.8156 7.88744 10.7305 8.09288 10.7305 8.3071V10.7302C10.7305 10.9444 10.8156 11.1498 10.9671 11.3013C11.1185 11.4528 11.324 11.5379 11.5382 11.5379C11.7524 11.5379 11.9578 11.4528 12.1093 11.3013C12.2608 11.1498 12.3459 10.9444 12.3459 10.7302V8.3071C12.3459 8.09288 12.2608 7.88744 12.1093 7.73597C11.9578 7.5845 11.7524 7.49941 11.5382 7.49941Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const NEW_EDITED_ICON = (backgroundColor = '#F2F2F2'): JSX.Element => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.461914" width="23.0769" height="23.0769" rx="1.15385" fill={backgroundColor} />
    <path
      d="M17.9885 5.5506C17.6855 5.24776 17.2747 5.07764 16.8464 5.07764C16.418 5.07764 16.0072 5.24776 15.7043 5.5506L9.57715 11.6778V13.9619H11.8613L17.9885 7.83475C18.2913 7.53182 18.4614 7.12102 18.4614 6.69268C18.4614 6.26433 18.2913 5.85353 17.9885 5.5506Z"
      fill="#4F4F4F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.53857 8.30972C5.53857 7.88129 5.70877 7.47041 6.01171 7.16747C6.31465 6.86453 6.72553 6.69434 7.15396 6.69434H10.3847C10.5989 6.69434 10.8044 6.77943 10.9559 6.9309C11.1073 7.08238 11.1924 7.28781 11.1924 7.50203C11.1924 7.71624 11.1073 7.92168 10.9559 8.07315C10.8044 8.22462 10.5989 8.30972 10.3847 8.30972H7.15396V16.3866H15.2309V13.1559C15.2309 12.9417 15.316 12.7362 15.4674 12.5847C15.6189 12.4333 15.8244 12.3482 16.0386 12.3482C16.2528 12.3482 16.4582 12.4333 16.6097 12.5847C16.7612 12.7362 16.8463 12.9417 16.8463 13.1559V16.3866C16.8463 16.8151 16.6761 17.2259 16.3731 17.5289C16.0702 17.8318 15.6593 18.002 15.2309 18.002H7.15396C6.72553 18.002 6.31465 17.8318 6.01171 17.5289C5.70877 17.2259 5.53857 16.8151 5.53857 16.3866V8.30972Z"
      fill="#4F4F4F"
    />
  </svg>
);

export const NEW_AGAINST_POLICY_ICON = (backgroundColor = '#F2F2F2'): JSX.Element => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.922852" width="23.0769" height="23.0769" rx="1.15385" fill={backgroundColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.53857 9.694V5.07861L19.3847 11.0127L5.53857 16.9467V12.3314L15.4287 11.0127L5.53857 9.694ZM15.7745 14.5252C15.5575 14.3083 15.2058 14.3083 14.9888 14.5252C14.7718 14.7422 14.7718 15.094 14.9888 15.3109L15.8885 16.2106L14.9888 17.1103C14.7718 17.3272 14.7718 17.679 14.9888 17.8959C15.2058 18.1129 15.5575 18.1129 15.7745 17.8959L16.6742 16.9963L17.5738 17.8959C17.7908 18.1129 18.1425 18.1129 18.3595 17.8959C18.5765 17.679 18.5765 17.3272 18.3595 17.1103L17.4598 16.2106L18.3595 15.3109C18.5765 15.094 18.5765 14.7422 18.3595 14.5252C18.1425 14.3083 17.7908 14.3083 17.5738 14.5252L16.6742 15.4249L15.7745 14.5252Z"
      fill="#EB5757"
    />
  </svg>
);

// key actions redesign icons

export const SENT_ICON = (
  <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.82181 11.836L13.9758 19.926L20.0218 1.80005L1.7998 7.55005L9.82181 11.836Z"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.72217 11.934L20.0222 1.80005"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WITHIN_POLICY_ICON_REDESIGN = (colorChange = false): JSX.Element => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <g clipPath="url(#clip0_11381_23970)">
      <path
        d="M10.875 6.28934V3.27524C10.875 3.15812 10.8067 3.05038 10.6972 2.99416L6.05376 0.61061C5.9503 0.557205 5.82575 0.557205 5.7223 0.61061L1.07781 2.99416C0.968326 3.05038 0.900024 3.15812 0.900024 3.27524V6.28934C0.9171 7.12789 1.18227 7.94771 1.66741 8.65977C2.15255 9.37184 2.83958 9.95086 3.65417 10.3341L5.7223 11.3891C5.82475 11.4415 5.9493 11.4415 6.05175 11.3891L8.11987 10.3341C8.94551 9.9265 9.64158 9.33155 10.1428 8.60637C10.6209 7.91304 10.874 7.11009 10.875 6.28934Z"
        fill="#16B126"
      />
      <path
        d="M3.47644 7.28904L5.00719 8.71693L8.98876 4.24121"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11381_23970">
        <rect
          width="9.975"
          height="10.8571"
          fill="white"
          transform="translate(0.900024 0.571289)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WARNING_ICON_REDESIGN = (colorChange = false): JSX.Element => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <path
      d="M1.6712 10.117L6.51644 1.48244C6.56476 1.39672 6.63501 1.32539 6.71997 1.27575C6.80494 1.22611 6.90157 1.19995 6.99997 1.19995C7.09838 1.19995 7.19501 1.22611 7.27998 1.27575C7.36494 1.32539 7.43519 1.39672 7.48351 1.48244L12.3288 10.117C12.3762 10.2012 12.4007 10.2963 12.4 10.3929C12.3992 10.4895 12.3731 10.5842 12.3243 10.6676C12.2755 10.7509 12.2057 10.82 12.1218 10.868C12.038 10.916 11.943 10.9412 11.8464 10.941H2.1535C2.0569 10.9412 1.96195 10.916 1.87811 10.868C1.79426 10.82 1.72447 10.7509 1.67567 10.6676C1.62687 10.5842 1.60078 10.4895 1.59999 10.3929C1.59921 10.2963 1.62376 10.2012 1.6712 10.117V10.117Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 3.78052V8.21376"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.94725 10.0776C7.18637 10.0776 7.38021 9.88375 7.38021 9.64463C7.38021 9.40551 7.18637 9.21167 6.94725 9.21167C6.70813 9.21167 6.51428 9.40551 6.51428 9.64463C6.51428 9.88375 6.70813 10.0776 6.94725 10.0776Z"
      fill="#333333"
    />
  </svg>
);

export const EDITED_ICON_REDESIGN = (colorChange = false): JSX.Element => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <path
      d="M12.3564 4.09924L9.97717 1.71997L2.24538 9.45176L4.62466 11.831L12.3564 4.09924Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.62397 11.8315L1.71997 12.3571L2.24437 9.4519"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.85034 2.84717L10.3923 4.38917"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AGAINST_POLICY_ICON_REDESIGN = (colorChange = false): JSX.Element => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <path
      d="M5.28495 6.54894L7.30261 10.4784L10.2392 1.67432L1.38855 4.46717L5.28495 6.54894Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.23645 6.59654L10.2393 1.67432"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.0686 8.78271L12.3966 12.1112"
      stroke="#F8351A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3966 8.78271L9.0686 12.1112"
      stroke="#F8351A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ABANDONED_ICON_REDESIGN = (colorChange = false): JSX.Element => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <path
      d="M1.68005 1.67993L10.4161 10.4171"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4161 1.67993L1.68005 10.4171"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NOTIFY_AUTHOR_ICON = (colorChange = false): JSX.Element => (
  <svg
    width="100%"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-litlingo-gray-6 ${colorChange && 'hover:text-litlingo-info'}`}
  >
    <path
      d="M18.614 15.844V17.254H1.4V15.844C1.40038 15.3541 1.56222 14.8779 1.8605 14.4893C2.15878 14.1006 2.57685 13.8211 3.05 13.694V9.79C3.04904 8.20698 3.58851 6.67106 4.57919 5.43635C5.56987 4.20163 6.95239 3.34212 8.498 3V2.346C8.498 1.93598 8.66088 1.54275 8.95081 1.25282C9.24074 0.962886 9.63397 0.800003 10.044 0.800003C10.454 0.800003 10.8473 0.962886 11.1372 1.25282C11.4271 1.54275 11.59 1.93598 11.59 2.346V3.016C13.1187 3.37377 14.4816 4.2379 15.4572 5.46802C16.4328 6.69814 16.9638 8.22198 16.964 9.792V13.696C17.4368 13.823 17.8546 14.1022 18.1529 14.4905C18.4511 14.8787 18.6132 15.3544 18.614 15.844V15.844Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.686 17.254C12.527 17.8322 12.1826 18.3422 11.7056 18.7057C11.2287 19.0692 10.6456 19.266 10.046 19.266C9.44633 19.266 8.86326 19.0692 8.38633 18.7057C7.9094 18.3422 7.56498 17.8322 7.40598 17.254"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TAG_POLICY_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_625_1345" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00134767 10.3749C0.00185706 10.3744 0.00151451 10.3735 0.00079463 10.3735C0.000351147 10.3735 0 10.3731 0 10.3727V3C0 1.34314 1.34315 0 3 0H10.3763H10.3773C10.3789 0 10.3803 0.00128425 10.3803 0.00290551C10.3804 0.00366687 10.3807 0.00438963 10.3812 0.00492834L19.1231 8.7468C20.2946 9.91837 20.2946 11.8179 19.1231 12.9894L12.9894 19.1231C11.8178 20.2947 9.91834 20.2947 8.74677 19.1231L0.000794408 10.3771C0.000339108 10.3767 0.000338889 10.3759 0.000794208 10.3755L0.00134767 10.3749Z"
      />
    </mask>
    <path
      d="M0.000794408 10.3771L-1.05987 11.4378L0.000794408 10.3771ZM0.000794208 10.3755L-1.05982 9.31478L0.000794208 10.3755ZM12.9894 19.1231L11.9287 18.0624L12.9894 19.1231ZM8.74677 19.1231L7.68611 20.1838L8.74677 19.1231ZM10.3812 0.00492834L9.32054 1.06559L10.3812 0.00492834ZM0.00134767 10.3749L1.06197 11.4356L0.00134767 10.3749ZM1.5 10.3727V3H-1.5V10.3727H1.5ZM3 1.5H10.3763V-1.5H3V1.5ZM10.3763 1.5H10.3773V-1.5H10.3763V1.5ZM9.32054 1.06559L18.0624 9.80746L20.1837 7.68614L11.4419 -1.05573L9.32054 1.06559ZM18.0624 11.9288L11.9287 18.0624L14.0501 20.1838L20.1837 14.0501L18.0624 11.9288ZM9.80743 18.0624L1.06145 9.31647L-1.05987 11.4378L7.68611 20.1838L9.80743 18.0624ZM1.06141 11.4362L1.06197 11.4356L-1.05927 9.31423L-1.05982 9.31478L1.06141 11.4362ZM1.06145 9.31647C1.64641 9.90143 1.64717 10.8505 1.06141 11.4362L-1.05982 9.31478C-1.6465 9.9014 -1.64573 10.8519 -1.05987 11.4378L1.06145 9.31647ZM11.9287 18.0624C11.343 18.6482 10.3932 18.6482 9.80743 18.0624L7.68611 20.1838C9.44347 21.9411 12.2927 21.9411 14.0501 20.1838L11.9287 18.0624ZM18.0624 9.80746C18.6482 10.3932 18.6482 11.343 18.0624 11.9288L20.1837 14.0501C21.9411 12.2927 21.9411 9.44349 20.1837 7.68614L18.0624 9.80746ZM10.3773 1.5C9.57145 1.5 8.91021 0.862069 8.88129 0.0567317L11.8794 -0.0509207C11.8503 -0.859501 11.1864 -1.5 10.3773 -1.5V1.5ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5V-1.5C0.514721 -1.5 -1.5 0.514713 -1.5 3H1.5ZM0.0556128 8.87452C0.861724 8.904 1.5 9.56604 1.5 10.3727H-1.5C-1.5 11.1802 -0.861022 11.843 -0.0540236 11.8725L0.0556128 8.87452ZM8.88129 0.0567317C8.89492 0.43645 9.05187 0.796914 9.32054 1.06559L11.4419 -1.05573C11.7095 -0.788134 11.8658 -0.429116 11.8794 -0.0509207L8.88129 0.0567317ZM-0.0540236 11.8725C-1.36254 11.8247 -1.98518 10.2401 -1.05927 9.31423L1.06197 11.4356C1.9889 10.5088 1.36557 8.92243 0.0556128 8.87452L-0.0540236 11.8725Z"
      fill="#333333"
      mask="url(#path-1-inside-1_625_1345)"
    />
    <circle cx="5" cy="5" r="1" fill="#333333" />
  </svg>
);

export const REVIEW_ACTIVITY_LOG_ICON = (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.8361 10.0219C17.403 13.4932 13.9857 15.9332 10 15.9332C6.01398 15.9332 2.59532 13.4929 1.16382 10.0219C2.59384 6.5493 6.01245 4.10762 10 4.10762C13.9873 4.10762 17.4045 6.54904 18.8361 10.0219Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.483C11.9123 13.483 13.4626 11.9327 13.4626 10.0204C13.4626 8.10807 11.9123 6.55782 10 6.55782C8.08767 6.55782 6.53743 8.10807 6.53743 10.0204C6.53743 11.9327 8.08767 13.483 10 13.483Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const COMMENT_ICON = (colorChange = false): JSX.Element => (
  <svg
    width="100%"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={`${colorChange && 'hover:text-litlingo-info'}`}
  >
    <mask id="path-1-inside-1_609_1296" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1C1.34315 1 0 2.34315 0 4V14C0 15.6569 1.34315 17 3 17H15.3636L18.4567 19.0014C19.1221 19.432 20 18.9544 20 18.1619V14V10V4C20 2.34315 18.6569 1 17 1H3Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1C1.34315 1 0 2.34315 0 4V14C0 15.6569 1.34315 17 3 17H15.3636L18.4567 19.0014C19.1221 19.432 20 18.9544 20 18.1619V14V10V4C20 2.34315 18.6569 1 17 1H3Z"
      fill="white"
    />
    <path
      d="M15.3636 17L16.1785 15.7406L15.8066 15.5H15.3636V17ZM18.4567 19.0014L19.2716 17.7421H19.2716L18.4567 19.0014ZM1.5 4C1.5 3.17157 2.17157 2.5 3 2.5V-0.5C0.514719 -0.5 -1.5 1.51472 -1.5 4H1.5ZM1.5 14V4H-1.5V14H1.5ZM3 15.5C2.17157 15.5 1.5 14.8284 1.5 14H-1.5C-1.5 16.4853 0.514718 18.5 3 18.5V15.5ZM15.3636 15.5H3V18.5H15.3636V15.5ZM19.2716 17.7421L16.1785 15.7406L14.5488 18.2594L17.6419 20.2608L19.2716 17.7421ZM18.5 18.1619C18.5 17.7656 18.9389 17.5268 19.2716 17.7421L17.6419 20.2608C19.3053 21.3371 21.5 20.1431 21.5 18.1619H18.5ZM18.5 14V18.1619H21.5V14H18.5ZM18.5 10V14H21.5V10H18.5ZM18.5 4V10H21.5V4H18.5ZM17 2.5C17.8284 2.5 18.5 3.17157 18.5 4H21.5C21.5 1.51472 19.4853 -0.5 17 -0.5V2.5ZM3 2.5H17V-0.5H3V2.5Z"
      fill="currentColor"
      mask="url(#path-1-inside-1_609_1296)"
    />
    <rect x="4" y="5" width="12" height="1.5" rx="0.75" fill="currentColor" />
    <rect x="4" y="8" width="12" height="1.5" rx="0.75" fill="currentColor" />
    <rect x="4" y="11" width="7" height="1.5" rx="0.75" fill="currentColor" />
  </svg>
);

export const ENVELOPE_EXPAND_ICON = (selected = false): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={selected ? 'text-litlingo-gray-5' : 'text-litlingo-gray-3'}
  >
    <rect x="4" y="5" width="16" height="2" fill="currentColor" />
    <rect x="4" y="11" width="16" height="2" fill="currentColor" />
    <rect x="4" y="17" width="16" height="2" fill="currentColor" />
  </svg>
);
export const ENVELOPE_EXPAND_ALTER_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#5C5C5C" />
    <rect x="4" y="5" width="16" height="2" fill="white" />
    <rect x="4" y="11" width="16" height="2" fill="white" />
    <rect x="4" y="17" width="16" height="2" fill="white" />
  </svg>
);
export const ENVELOPE_CONTRACT_ICON = (selected = false): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={selected ? 'text-litlingo-gray-5' : 'text-litlingo-gray-3'}
  >
    <rect x="4" y="7" width="16" height="2" fill="currentColor" />
    <rect x="4" y="11" width="16" height="2" fill="currentColor" />
    <rect x="4" y="15" width="16" height="2" fill="currentColor" />
  </svg>
);
export const ENVELOPE_CONTRACT_ALTER_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#5C5C5C" />
    <rect x="4" y="7" width="16" height="2" fill="white" />
    <rect x="4" y="11" width="16" height="2" fill="white" />
    <rect x="4" y="15" width="16" height="2" fill="white" />
  </svg>
);

export const LINK_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6666 13.8898L8.33329 17.2231C6.80219 18.7542 4.31001 18.7553 2.77776 17.2231C1.24666 15.692 1.24666 13.1987 2.77776 11.6675L6.11108 8.33423C6.41775 8.02756 6.91551 8.02756 7.22219 8.33423C7.52886 8.6409 7.52886 9.13867 7.22219 9.44534L3.88887 12.7787C2.96999 13.6975 2.96999 15.1931 3.88887 16.112C4.80775 17.0309 6.3033 17.0309 7.22219 16.112L10.5555 12.7787C10.8622 12.472 11.3599 12.472 11.6666 12.7787C11.9733 13.0853 11.9733 13.5831 11.6666 13.8898Z"
      fill="#333333"
    />
    <path
      d="M17.2222 8.33463L13.8889 11.6679C13.5822 11.9746 13.0845 11.9746 12.7778 11.6679C12.4711 11.3613 12.4711 10.8635 12.7778 10.5568L16.1111 7.22352C17.03 6.30464 17.03 4.80909 16.1111 3.8902C15.1922 2.97132 13.6967 2.97132 12.7778 3.8902L9.44449 7.22352C9.13782 7.53019 8.64006 7.53019 8.33338 7.22352C8.02671 6.91685 8.02671 6.41909 8.33338 6.11242L11.6667 2.7791C13.1989 1.24685 15.6911 1.248 17.2222 2.7791C18.7545 4.31135 18.7545 6.80238 17.2222 8.33463Z"
      fill="#333333"
    />
    <path
      d="M12.7776 8.33574L8.33316 12.7802C8.02649 13.0868 7.52873 13.0868 7.22206 12.7802C6.91539 12.4735 6.91539 11.9757 7.22206 11.6691L11.6665 7.22463C11.9731 6.91796 12.4709 6.91796 12.7776 7.22464C13.0843 7.53131 13.0843 8.02907 12.7776 8.33574Z"
      fill="#333333"
    />
  </svg>
);

export const COPY_ID_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.491118 3.66632H3.10007V0.491599C3.10007 0.219874 3.31994 0 3.59167 0H18.9422C19.2139 0 19.4338 0.219874 19.4338 0.491599V15.8421C19.4338 16.1138 19.2139 16.3337 18.9422 16.3337H16.3332V19.5084C16.3332 19.7801 16.1133 20 15.8416 20H0.491118C0.219393 20 -0.000480652 19.7801 -0.000480652 19.5084V4.15792C-0.000480652 3.88619 0.219393 3.66632 0.491118 3.66632ZM4.08392 3.66632H15.8423C16.114 3.66632 16.3339 3.88619 16.3339 4.15792V15.3505H18.4512V0.983854H4.08392V3.66632ZM15.35 4.65017H3.59167H0.982717V19.0168H15.35V15.8421V4.65017Z"
      fill="#333333"
    />
    <path
      d="M3.49261 8H5.11261V15H3.49261V8ZM6.77386 8H9.95386C10.7139 8 11.3839 8.14667 11.9639 8.44C12.5505 8.72667 13.0039 9.13333 13.3239 9.66C13.6505 10.1867 13.8139 10.8 13.8139 11.5C13.8139 12.2 13.6505 12.8133 13.3239 13.34C13.0039 13.8667 12.5505 14.2767 11.9639 14.57C11.3839 14.8567 10.7139 15 9.95386 15H6.77386V8ZM9.87386 13.67C10.5739 13.67 11.1305 13.4767 11.5439 13.09C11.9639 12.6967 12.1739 12.1667 12.1739 11.5C12.1739 10.8333 11.9639 10.3067 11.5439 9.92C11.1305 9.52667 10.5739 9.33 9.87386 9.33H8.39386V13.67H9.87386Z"
      fill="black"
    />
  </svg>
);

export const SHIELD_ICON = (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45 27.2765V13.5036L25 2.5L5 13.5036V27.2765C5.06942 30.8831 6.133 34.4039 8.07801 37.4651C10.023 40.5262 12.7767 43.0133 16.0466 44.6622L25 49.5588L33.9534 44.6622C37.2628 42.9112 40.0568 40.3531 42.0657 37.2348C43.9815 34.2533 44.9985 30.801 45 27.2765Z"
      fill="currentColor"
    />
    <path
      d="M15.1641 29.7113L21.2516 35.8016L37.0944 16.7117"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RECIPIENTS_ICON = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.31844 6.02088C4.32216 6.02302 4.32588 6.02525 4.3296 6.02758C4.41479 6.07929 4.5025 6.12728 4.59253 6.17118C4.5996 6.17434 4.60657 6.17769 4.61364 6.18094C4.64954 6.19806 4.68581 6.21452 4.72227 6.23024C4.73371 6.23517 4.74524 6.24037 4.75678 6.24521C4.79882 6.26279 4.84104 6.27971 4.88401 6.29562C4.89071 6.29804 4.89731 6.30018 4.90401 6.30278C4.94149 6.31636 4.97944 6.3292 5.01757 6.34129C5.03422 6.34677 5.05077 6.3517 5.06742 6.35673C5.09765 6.36593 5.12825 6.37449 5.15884 6.38277C5.17428 6.38686 5.18982 6.39142 5.20553 6.3956C5.24766 6.40611 5.29017 6.41597 5.33305 6.42518C5.34969 6.42862 5.36634 6.43188 5.38318 6.43504C5.41424 6.44108 5.4454 6.44648 5.47693 6.45187C5.49376 6.45466 5.51041 6.45745 5.52715 6.45996C5.57207 6.46666 5.61718 6.47261 5.66275 6.47726C5.67317 6.47847 5.68359 6.47912 5.69391 6.48005C5.73297 6.48368 5.77222 6.48684 5.81166 6.48898C5.8257 6.48982 5.83956 6.49075 5.85351 6.49121C5.90234 6.49345 5.95126 6.49493 6.00055 6.49493C6.04985 6.49493 6.09886 6.49335 6.1475 6.49121C6.16155 6.49066 6.17541 6.48973 6.18954 6.48898C6.22888 6.48675 6.26795 6.48368 6.30701 6.48005C6.31743 6.47912 6.32794 6.47847 6.33817 6.47726C6.38365 6.47261 6.42866 6.46657 6.47368 6.45996C6.4906 6.45745 6.50744 6.45476 6.52418 6.45187C6.55552 6.44657 6.58668 6.44108 6.61775 6.43522C6.63458 6.43188 6.65132 6.42871 6.66825 6.42518C6.71094 6.41616 6.75344 6.40611 6.79548 6.3956C6.81139 6.3916 6.82692 6.38695 6.84282 6.38267C6.87323 6.3744 6.90337 6.36603 6.93323 6.35682C6.95015 6.3518 6.96699 6.34668 6.98363 6.34138C7.02139 6.32929 7.05869 6.31655 7.0958 6.30325C7.10324 6.30046 7.11087 6.29795 7.11831 6.29525C7.16044 6.27934 7.20229 6.2627 7.24377 6.24521C7.25549 6.24037 7.2674 6.23517 7.27912 6.23014C7.31529 6.21452 7.35129 6.19824 7.38672 6.18122C7.39407 6.17787 7.40142 6.17443 7.40858 6.17099C7.45341 6.14923 7.49777 6.12644 7.54148 6.10263C7.54158 6.10254 7.54186 6.10235 7.54204 6.10235C7.58566 6.07836 7.62845 6.05352 7.67086 6.02785C7.67486 6.02534 7.67876 6.02292 7.68276 6.02051C8.61367 5.44955 9.23634 4.42024 9.23634 3.2474C9.23671 1.45684 7.78498 0 6.00061 0C4.2162 0 2.7644 1.45686 2.7644 3.2474C2.7644 4.4204 3.38726 5.44998 4.31853 6.02098L4.31844 6.02088Z"
      fill="#ADADAD"
    />
    <path
      d="M11.6565 9.62273C11.0611 7.89448 9.78999 6.80986 7.87796 6.39795C7.83452 6.42399 7.79034 6.44892 7.74598 6.47319C7.74319 6.47468 7.7404 6.47617 7.73761 6.47756C7.69185 6.5024 7.6459 6.52593 7.59922 6.54862C7.59187 6.55225 7.58443 6.55597 7.57708 6.5596C7.52797 6.58322 7.47868 6.60563 7.42883 6.62702C7.42139 6.63009 7.41385 6.63307 7.40641 6.63623C7.36521 6.65335 7.32392 6.66971 7.28215 6.68534C7.26709 6.69092 7.25193 6.69669 7.23686 6.70217C7.19045 6.71882 7.14395 6.73501 7.09698 6.74961C7.0847 6.75351 7.07233 6.75695 7.05987 6.76068C7.02109 6.77239 6.98212 6.78346 6.94306 6.79416C6.92408 6.79909 6.90501 6.8042 6.88595 6.80885C6.84559 6.8189 6.80504 6.82829 6.76411 6.83713C6.7469 6.84085 6.72942 6.84429 6.71212 6.84791C6.66962 6.85628 6.62693 6.86391 6.58414 6.87089C6.56591 6.87386 6.54778 6.87675 6.52936 6.87926C6.48379 6.88577 6.43803 6.89181 6.39218 6.89674C6.38334 6.89777 6.3746 6.89897 6.36595 6.89972C6.31433 6.90493 6.26262 6.90865 6.21044 6.91181C6.19575 6.91246 6.18115 6.91311 6.16645 6.91395C6.11111 6.91646 6.05596 6.91823 6.00043 6.91823C5.945 6.91823 5.88976 6.91637 5.83442 6.91395C5.81991 6.91311 5.80512 6.91246 5.79042 6.91181C5.73843 6.90874 5.68653 6.90483 5.63492 6.89972C5.62627 6.89888 5.61743 6.89767 5.60869 6.89674C5.56284 6.89181 5.51708 6.88577 5.4715 6.87926C5.45309 6.87656 5.43495 6.87377 5.41672 6.87089C5.37394 6.86391 5.33116 6.85638 5.28875 6.84791C5.27145 6.84429 5.25406 6.84085 5.23685 6.83713C5.19592 6.82848 5.15537 6.8189 5.11482 6.80885C5.09576 6.8042 5.07678 6.79909 5.0579 6.79416C5.01875 6.78346 4.97959 6.77239 4.94081 6.76068C4.92853 6.75695 4.91616 6.75351 4.90398 6.7497C4.85692 6.73491 4.81023 6.71873 4.76382 6.70208C4.74875 6.69659 4.73378 6.69111 4.7189 6.68543C4.67704 6.66971 4.63556 6.65316 4.59408 6.63595C4.58673 6.63288 4.57939 6.63009 4.57204 6.62703C4.522 6.60573 4.47261 6.58313 4.42351 6.5596C4.41616 6.55597 4.409 6.55243 4.40165 6.54881C4.35487 6.52611 4.30874 6.50231 4.2627 6.47747C4.26 6.47589 4.2574 6.47468 4.2547 6.47319C4.21015 6.44892 4.16588 6.42399 4.12226 6.39795C2.20494 6.81071 0.932244 7.9002 0.338908 9.63654C-0.00866542 10.6543 -0.0119988 11.6078 0.00557274 11.9999H11.9947C12.0122 11.6051 12.0082 10.6425 11.6566 9.62268L11.6565 9.62273Z"
      fill="#ADADAD"
    />
  </svg>
);

export const TAGS_ICON = (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_6080_100144" fill="white">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22522 0H6.22584C6.22681 0 6.22761 0.000770105 6.22765 0.00174222C6.22766 0.00219878 6.22785 0.0026322 6.22818 0.00295524L11.3313 5.10608C12.1124 5.88713 12.1124 7.15346 11.3313 7.93451L7.9345 11.3313C7.15345 12.1124 5.88712 12.1124 5.10607 11.3313L0.000476206 6.22573C0.000203049 6.22546 0.000203275 6.22502 0.000476418 6.22474L0.000808638 6.22441C0.0011142 6.2241 0.000908629 6.22358 0.000476767 6.22357C0.000210697 6.22356 0 6.22334 0 6.22307V2C0 0.895433 0.895431 0 2 0H6.22522Z"
      />
    </mask>
    <path
      d="M0.000808638 6.22441L0.707949 6.93148L0.000808638 6.22441ZM0.000476206 6.22573L-0.706631 6.93284L0.000476206 6.22573ZM0.000476418 6.22474L-0.706664 5.51767L0.000476418 6.22474ZM11.3313 7.93451L12.0384 8.64162L11.3313 7.93451ZM6.22818 0.00295524L5.52107 0.710062L6.22818 0.00295524ZM6.22522 1H6.22584V-1H6.22522V1ZM5.52107 0.710062L10.6242 5.81319L12.0384 4.39898L6.93528 -0.704152L5.52107 0.710062ZM10.6242 7.22741L7.22739 10.6242L8.6416 12.0384L12.0384 8.64162L10.6242 7.22741ZM5.81318 10.6242L0.707583 5.51862L-0.706631 6.93284L4.39896 12.0384L5.81318 10.6242ZM0.707617 6.93182L0.707949 6.93148L-0.706332 5.51734L-0.706664 5.51767L0.707617 6.93182ZM1 6.22307V2H-1V6.22307H1ZM2 1H6.22522V-1H2V1ZM1 2C1 1.44772 1.44772 1 2 1V-1C0.343144 -1 -1 0.34315 -1 2H1ZM0.0368473 5.22423C0.574356 5.24379 1 5.68521 1 6.22307H-1C-1 6.76147 -0.573935 7.20332 -0.0358938 7.2229L0.0368473 5.22423ZM0.707949 6.93148C1.32585 6.31353 0.910147 5.25601 0.0368473 5.22423L-0.0358938 7.2229C-0.90833 7.19115 -1.32362 6.13468 -0.706332 5.51734L0.707949 6.93148ZM0.707583 5.51862C1.09826 5.9093 1.0974 6.542 0.707617 6.93182L-0.706664 5.51767C-1.09699 5.90803 -1.09785 6.54161 -0.706631 6.93284L0.707583 5.51862ZM7.22739 10.6242C6.83686 11.0147 6.2037 11.0147 5.81318 10.6242L4.39896 12.0384C5.57053 13.21 7.47003 13.21 8.6416 12.0384L7.22739 10.6242ZM10.6242 5.81319C11.0147 6.20372 11.0147 6.83688 10.6242 7.22741L12.0384 8.64162C13.21 7.47005 13.21 5.57055 12.0384 4.39898L10.6242 5.81319ZM5.22829 0.0374928C5.23734 0.290635 5.34196 0.530949 5.52107 0.710062L6.93528 -0.704152C7.11375 -0.525685 7.21799 -0.286237 7.22701 -0.0340084L5.22829 0.0374928ZM6.22584 1C5.68844 1 5.2475 0.574548 5.22829 0.0374928L7.22701 -0.0340084C7.20773 -0.573007 6.76519 -1 6.22584 -1V1Z"
      fill="#858585"
      mask="url(#path-1-inside-1_6080_100144)"
    />
    <circle cx="3.1499" cy="3.1499" r="0.75" fill="#858585" />
  </svg>
);

export const DOWNLOAD_ATTACHMENT_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 20 20" fill="none">
    <path
      d="M6.91016 9.33848L9.87296 12.3167L12.8821 9.30762"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.82617 4.40039L9.87247 12.3166"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.7002 11.2979V16.1124H16.2304V11.2979"
      stroke="white"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ATTACHMENT_ICON = (
  <svg width="100%" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.287 0.719081C10.8706 0.294818 10.3115 0.0401396 9.71823 0.00458835C9.13424 -0.0346357 8.56156 0.179034 8.14622 0.591411L2.39439 6.34324C2.13185 6.60591 1.9951 6.96893 2.01913 7.33949C2.04292 7.70369 2.19829 8.04668 2.45636 8.30477C2.71443 8.56273 3.05766 8.71797 3.42176 8.74152C3.79151 8.76672 4.15405 8.63068 4.41602 8.36848L9.06543 3.71908C9.19488 3.58504 9.244 3.39269 9.19476 3.21295C9.14553 3.0332 9.00512 2.89281 8.82538 2.84356C8.64563 2.79433 8.45328 2.84345 8.31925 2.9729L3.66773 7.62411C3.61649 7.67347 3.54582 7.69749 3.47515 7.68949C3.37138 7.67959 3.27444 7.63389 3.20082 7.56015C3.12708 7.48654 3.08138 7.38948 3.07148 7.28582C3.06489 7.21527 3.08868 7.14518 3.13686 7.09324L8.892 1.33991C9.09778 1.14214 9.37763 1.04072 9.66246 1.06075C9.99509 1.08277 10.3079 1.22718 10.5406 1.46604C10.7739 1.66935 10.9179 1.95616 10.9415 2.26476C10.9651 2.57323 10.8664 2.87866 10.6666 3.11506L4.52549 9.25617C4.17179 9.60225 3.68649 9.77961 3.19306 9.74322C2.63793 9.70776 2.11567 9.46795 1.72719 9.06995C1.33459 8.72188 1.0949 8.2333 1.05992 7.70986C1.02494 7.18642 1.1975 6.67025 1.54039 6.27319L6.57758 1.236C6.71127 1.10266 6.76356 0.9082 6.71503 0.72586C6.66639 0.543406 6.52422 0.400773 6.34188 0.351652C6.15966 0.302535 5.96508 0.354479 5.83138 0.487697L0.794195 5.52488C0.252362 6.11981 -0.0321981 6.90502 0.00290084 7.70904C0.0378852 8.51306 0.389472 9.27043 0.981028 9.81615C1.55371 10.3984 2.32194 10.7478 3.13714 10.7971C3.19203 10.8003 3.24668 10.8018 3.30122 10.8018C4.03881 10.8104 4.74896 10.5224 5.27216 10.0024L11.4133 3.86064C11.8115 3.42658 12.0219 2.8526 11.9982 2.26403C11.9745 1.67543 11.7187 1.11979 11.287 0.719081Z"
      fill="currentColor"
    />
  </svg>
);

export const MESSAGE_ICON = (
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.247115 0.000283121C0.106528 0.0134011 -0.000678587 0.130801 3.23402e-06 0.270848V7.84708C3.23402e-06 7.99648 0.122042 8.11765 0.272707 8.11765H11.7273C11.878 8.11765 12 7.99647 12 7.84708V0.270848C12 0.121454 11.878 0.000283121 11.7273 0.000283121H0.272707C0.264147 -9.43738e-05 0.255681 -9.43738e-05 0.247119 0.000283121H0.247115ZM0.954528 0.541412H11.0455L6 5.04405L0.954528 0.541412ZM0.545411 0.905039L3.88195 3.88151L0.545411 7.19187V0.905039ZM11.4545 0.905039V7.19163L8.118 3.88127L11.4545 0.905039ZM4.2869 4.24512L5.81671 5.61069L5.81681 5.6106C5.92077 5.70422 6.07924 5.70422 6.18321 5.6106L7.71302 4.24502L11.071 7.5764H0.928909L4.28688 4.24502L4.2869 4.24512Z"
      fill="currentColor"
    />
  </svg>
);

export const CODE_MESSAGES_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.9274 5.16565L14.9619 1.2002L2.0756 14.0865L6.04106 18.052L18.9274 5.16565Z"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0402 18.0524L1.2002 18.9284L2.07419 14.0864"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.084 3.07861L15.654 5.64861"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DOWNLOAD_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9457 5.58545L6.69104 9.81802L10.9897 14.1167"
      stroke="#333333"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 9.75195L6.69109 9.81809"
      stroke="#333333"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.146 1L1.26806 1L1.26806 18.9003L8.146 18.9003"
      stroke="#333333"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CLOSE_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.7998 2.7998L17.3598 17.3618"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3598 2.7998L2.7998 17.3618"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ROUNDED_PLUS_ICON = (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.543457" y="0.5" width="19" height="19" rx="3.5" fill="white" stroke="#ADADAD" />
    <path
      d="M10.0435 4.95996V14.9476"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.1098 10H5.12341"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PLUS_ICON = (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.04346 0.959961V10.9476"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1098 6H1.12341"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ALERT_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.895743 13.4895L7.35606 1.97675C7.4205 1.86245 7.51415 1.76734 7.62744 1.70116C7.74073 1.63497 7.86958 1.6001 8.00078 1.6001C8.13198 1.6001 8.26083 1.63497 8.37412 1.70116C8.48741 1.76734 8.58106 1.86245 8.6455 1.97675L15.1058 13.4895C15.1691 13.6017 15.2018 13.7286 15.2008 13.8574C15.1997 13.9861 15.1649 14.1124 15.0999 14.2236C15.0348 14.3347 14.9417 14.4269 14.8299 14.4909C14.7181 14.5548 14.5915 14.5884 14.4627 14.5882H1.53881C1.41002 14.5884 1.28341 14.5548 1.17162 14.4909C1.05983 14.4269 0.966769 14.3347 0.901705 14.2236C0.836641 14.1124 0.801851 13.9861 0.800806 13.8574C0.79976 13.7286 0.832493 13.6017 0.895743 13.4895V13.4895Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.04077V10.9518"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75613 12.8595C7.75613 12.7641 7.83346 12.6868 7.92885 12.6868C8.02424 12.6868 8.10156 12.7641 8.10156 12.8595C8.10156 12.9549 8.02424 13.0322 7.92885 13.0322C7.83346 13.0322 7.75613 12.9549 7.75613 12.8595Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const keyActionsIcons = {
  show_modal: WARNING_ICON,
  back_to_edit: EDITED_ICON,
  send_anyways: AGAINST_POLICY_ICON,
  sent_within_policy: WITHIN_POLICY_ICON,
  sent_out_of_policy: AGAINST_POLICY_ICON,
  timeout: AGAINST_POLICY_ICON,
};

export const keyActionsIconsRedesign = {
  show_modal: NEW_WARNING_ICON,
  back_to_edit: NEW_EDITED_ICON(),
  send_anyways: NEW_AGAINST_POLICY_ICON(),
  sent_within_policy: NEW_WITHIN_POLICY_ICON(),
  sent_out_of_policy: NEW_AGAINST_POLICY_ICON(),
  timeout: NEW_AGAINST_POLICY_ICON(),
  abandoned: ABANDONED_ICON_REDESIGN(true),
};

export const keyActionsIconsEventsRedesign = {
  show_modal: WARNING_ICON_REDESIGN(true),
  back_to_edit: EDITED_ICON_REDESIGN(true),
  send_anyways: AGAINST_POLICY_ICON_REDESIGN(true),
  sent_within_policy: WITHIN_POLICY_ICON_REDESIGN(true),
  sent_out_of_policy: AGAINST_POLICY_ICON_REDESIGN(true),
  timeout: AGAINST_POLICY_ICON_REDESIGN(true),
  abandoned: ABANDONED_ICON_REDESIGN(true),
};

export const activityLogIcon = {
  sent_out_of_policy: AGAINST_POLICY_ICON_REDESIGN(),
  timeout: AGAINST_POLICY_ICON_REDESIGN(),
  show_modal: WARNING_ICON_REDESIGN(),
  back_to_edit: EDITED_ICON_REDESIGN(),
  send_anyways: AGAINST_POLICY_ICON_REDESIGN(),
  sent_within_policy: WITHIN_POLICY_ICON_REDESIGN(),
  state_change: STATE_CHANGE_ICON,
  review: REVIEW_ACTIVITY_LOG_ICON,
  author_notify: NOTIFY_AUTHOR_ICON(),
  add_tag: TAG_POLICY_ICON,
  remove_tag: TAG_POLICY_ICON,
  comment: COMMENT_ICON(),

  slack_recipient: NOTIFY_AUTHOR_ICON(),
  slack_author: NOTIFY_AUTHOR_ICON(),
  slack_others: NOTIFY_AUTHOR_ICON(),
  slack_tombstone: WARNING_ICON_REDESIGN(),

  o365_teams_recipient: NOTIFY_AUTHOR_ICON(),
  o365_teams_author: NOTIFY_AUTHOR_ICON(),
  o365_teams_others: NOTIFY_AUTHOR_ICON(),
  o365_teams_tombstone: WARNING_ICON_REDESIGN(),
};

export const EVENT_READ = 'event_read';

export default GMAIL_ICON;
